import base from "../baseurl";
import token from "../getTk";

const showAll = async (companyId, types) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log(companyId, types);
  const Create = await api
    .post("good-delivery-events/showall", {
      json: {
        companyId,
        types,
      },
    })
    .json();
  return Create;
};

export default showAll;
